import { Box, ColorOptions, convertHexToRGBA, Image, ModBox, Spacer, Text } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'
import chatImg from '../../assets/images/chat_icon.png'
import { LinearGradientContainer } from '../../comps/LinearGradient'
import { SvgImage } from '../../comps/SvgImage'
import { getString } from '../../util/languageStrings'
import { chatbotAwarenessData } from '../Support/ChatbotAwareness'

const btnWidth = 64
const height = window.innerHeight
export const RenderChatbotAwarenessWeb = ({ onCancel, onPress, isSmallDevice }: any) => {
  return (
    <Box
      width="100%"
      height={height}
      minWidth={isSmallDevice ? '100%' : 500}
      justify="flex-end"
      paddingHorizontal={10}
      pb={19}>
      <Box>
        <ModBox show={true} bg={'WHITE'} ph={32} pv={32} borderRadius={25} overflow="hidden">
          <Box flexDirection={'row'} justifyContent="space-between">
            <Box f={1}>
              <Box align="flex-start">
                <LinearGradientContainer
                  customStyle={
                    {
                      borderRadius: 4,
                      overflow: 'hidden',
                      paddingHorizontal: 4,
                      paddingVertical: 2,
                    } as ViewStyle
                  }
                  angle={90}
                  useAngle={true}
                  colorArray={['#DF9F39', '#966D2E']}
                  direction="HORIZONTAL">
                  <Text fontFamily={'JioType-Bold'} fontSize={12} lineHeight={18} color="WHITE">
                    {getString(null, 'INTRODUCING')}
                  </Text>
                </LinearGradientContainer>
              </Box>

              <Spacer size={16} direction="vertical" />
              <Text fontFamily={'JioType-Black'} fontSize={24} lineHeight={28} color="BLACK_21">
                {getString(null, 'jioPayChatAssistant')}
              </Text>
              <Spacer size={24} direction="vertical" />
              <Box>
                {Object.keys(chatbotAwarenessData)?.map((i, key) => (
                  <Box key={`item-${key}`} flexDirection={'row'} pb={8}>
                    <Box>
                      <SvgImage imageName="SuccessIconTickSmall" />
                    </Box>
                    <Spacer size={12} direction="horizontal" />
                    <Box f={1}>
                      <Text fontFamily={'JioType-Medium'} fontSize={12} lineHeight={16} color="BLACK_21">
                        {chatbotAwarenessData[i]}
                      </Text>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
            <Box onPress={() => onCancel()} underlayColor={'TRANSPARENT'}>
              <SvgImage imageName="Close" />
            </Box>
          </Box>
        </ModBox>
        <Box align={'flex-end'} paddingRight={btnWidth / 2}>
          <SvgImage imageName="CaretIcon" />
        </Box>

        <Box
          //   position={'absolute'}
          right={btnWidth / 2 + 10}
          borderRightWidth={1}
          borderStyle="dashed"
          width={1}
          height={72}
          //   bottom={20}
          borderColor="WHITE"
          zIndex={1}
        />
        <Box
          justify="flex-end"
          alignSelf={'flex-end'}
          padding={4}
          borderRadius={45}
          borderWidth={1}
          zIndex={11}
          //   position="absolute"
          //   bottom={0}
          borderColor={convertHexToRGBA('#fff', 30) as ColorOptions}>
          <Box
            justify="flex-end"
            alignSelf={'flex-end'}
            padding={4}
            borderRadius={45}
            borderWidth={1}
            borderColor={convertHexToRGBA('#fff', 60) as ColorOptions}>
            <ModBox
              show={true}
              borderRadius={btnWidth / 2}
              width={btnWidth}
              height={btnWidth}
              justify="center"
              underlayColor={'TRANSPARENT' as ColorOptions}
              onPress={onPress}
              overflow={'hidden'}
              align="center">
              <Image width={btnWidth} resizeMode="stretch" height={btnWidth} source={chatImg} />
            </ModBox>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
